/**
 * Pushes an event to Google Tag Manager's dataLayer
 */
export function pushGTMEvent(event: string, data?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }

  window.dataLayer.push({
    event,
    ...data
  });
}
